import { useState, useEffect } from 'react';
import { IConfigKeyDetail } from '../../utils/types';
import useService from '../../utils/useService';

const useDetail = (keyName: string) => {
	const [detail, setDetail] = useState<IConfigKeyDetail | null>(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const { fetchKeyDetail } = useService();

	useEffect(() => {
		if (!keyName) return undefined;

		let cancelled = false;
		setLoading(true);
		setError('');

		fetchKeyDetail(decodeURIComponent(keyName))
			.then((data) => {
				if (!cancelled) {
					setDetail(data);
				}
			})
			.catch((err) => {
				if (!cancelled) {
					setError(err?.message || 'Failed to load config key detail');
				}
			})
			.finally(() => {
				if (!cancelled) {
					setLoading(false);
				}
			});

		return () => {
			cancelled = true;
		};
	}, [keyName, fetchKeyDetail]);

	return { detail, loading, error };
};

export default useDetail;
